import { IS_MESHULAM_PAYMENT, PAYPAL_CLIENT_ID } from './app-common';

type TConfigKey = keyof Window;

export const CONFIG_REQUIRED_PARAMS: TConfigKey[] = [
  'API_URL',
  'CNAME',
  ...((IS_MESHULAM_PAYMENT
    ? ['PRIVACY_POLICY_URL']
    : [
        ...(PAYPAL_CLIENT_ID
          ? (['PAYPAL_CLIENT_ID'] as const)
          : (['STRIPE_ACCOUNT', 'STRIPE_KEY'] as const)),
      ]) satisfies TConfigKey[]),
];

export const CONFIG_REQUIRED_PARAMS_MAPPED = CONFIG_REQUIRED_PARAMS.map((item) => ({
  name: item,
  value: window[item],
}));

export const THEME_REQUIRED_PROPERTY = '--color-theme-accent';
